// @flow
import * as React from 'react'
import shallowEqual from 'mz-utils/shallowEqual'
import { Label, Input, CheckContainer, CheckMark, RadioMark } from './elements'
import type { StyledBaseProps } from '../../../..'

// Types
import type { Meta, Input as InputType } from '../../core/BaseField'

export type Appearance = 'primary' | 'inverse' | 'primary-inverse'
export type Props = {
  input: InputType,
  label?: React.Node,
  disabled?: boolean,
  appearance: Appearance,
  color?: string,
  checkMarkColor?: string,
  meta: Meta,
  type: 'checkbox' | 'radio',
  inactiveValue: any,
  activeValue: any,
  activeValueComparator: (a: any, b: any) => boolean,
}
type ChangeEvent = {
  target: { checked: boolean },
}
export type BaseStyles = {
  $appearance: Appearance,
  $disabled?: boolean,
  $checked?: boolean,
  $focus?: boolean,
  $color?: string,
  $checkMarkColor?: string,
  $radio: boolean,
}
export type Styles = BaseStyles & StyledBaseProps

/**
 * Attractive checkbox component
 */
class CheckboxField extends React.Component<Props> {
  static defaultProps = {
    activeValueComparator: shallowEqual,
    activeValue: true,
    inactiveValue: false,
    type: 'checkbox',
    appearance: 'primary',
    color: 'primary',
    input: {},
    meta: {},
  }

  handleChange = (e: ChangeEvent) => {
    if (e && e.target) {
      const { onChange } = this.props.input
      const { activeValue, inactiveValue } = this.props
      const value = e.target.checked ? activeValue : inactiveValue
      onChange && onChange(value)
    }
  }

  render() {
    const {
      label,
      input,
      disabled,
      appearance,
      activeValue,
      meta,
      color,
      checkMarkColor,
      type,
      activeValueComparator,
    } = this.props

    const value = activeValueComparator(input.value, activeValue)
    const styleProps: Styles = {
      $color: color,
      $checkMarkColor: checkMarkColor,
      $appearance: appearance,
      $disabled: !!disabled,
      $checked: value,
      $focus: !!meta.active,
      $palette: () => {},
      $radio: type === 'radio',
    }
    const MarkComp = styleProps.$radio ? RadioMark : CheckMark

    return (
      <Label {...styleProps}>
        <Input
          {...styleProps}
          type={type}
          name={input.name || ''}
          checked={value}
          onChange={this.handleChange}
          onFocus={input.onFocus}
          onBlur={input.onBlur}
          disabled={disabled}
        />
        <CheckContainer {...styleProps}>
          <MarkComp size="xs" {...styleProps} />
        </CheckContainer>
        {label}
      </Label>
    )
  }
}

export default CheckboxField
